<template>
    <div class="center-container">
        <h3>Starting Game...</h3>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        difficulty: {
            type: String,
            default: null,
        },
        challenge: {
            type: String,
            default: null,
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.startGameAndRedirect();
        });
    },

    beforeRouteUpdate(to, from, next) {
        this.startGameAndRedirect();
        next();
    },
    methods: {
        async startGameAndRedirect() {
            console.log("starting game")
            try {
                let payload = {};

                if (this.difficulty !== null) {
                    payload.difficulty = this.difficulty;
                }

                if (this.challenge !== null) {
                    payload.challengeUuid = this.challenge
                }

                const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
                const response = await axios.post(`${apiBaseUrl}/api/create_game/`, payload);
                localStorage.setItem('gameUuid', response.data.uuid);

                if (typeof gtag !== "undefined") {
                    gtag('event', 'startedNewGame', {
                        uuid: response.data.uuid,
                        difficulty: this.difficulty || 'NORMAL'
                    });
                }

                this.$router.push({ name: 'play' }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }

    }
}
</script>

<style scoped>
.center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Full viewport height */
    text-align: center;
}
</style>